/* Villani Jewellers landing page
   Two jobs: the review carousel arrows, and the greyscale-to-colour
   image reveal for browsers without CSS scroll-driven animations.
   Everything is delegated or re-scannable so it survives re-renders. */
(function () {
  'use strict';

  /* ---- enquiry logging ----
     Paste the Apps Script /exec URL here to mirror every submission into the
     Google Sheet. Leave it empty and this does nothing at all; the Shopify
     email and the GA4 event are unaffected either way. */
  var VJ_SHEET_ENDPOINT = '';


  /* ---- one place that emits every event, both ways ----
     dataLayer for GTM-in-theme, Shopify.analytics.publish for a custom pixel.
     Only whichever one is listening picks it up, so there is no double count. */
  function vjEmit(name, payload) {
    payload = payload || {};
    payload.page = 'manufacturing-landing';

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'villani_' + name }, payload));
    } catch (e) {}

    /* Shopify.analytics is not guaranteed to exist yet, especially on a page
       that has just loaded. Retry briefly rather than dropping the event. */
    var tries = 0;
    (function publish() {
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('villani_' + name, payload);
          return;
        }
      } catch (e) { return; }
      if (++tries < 40) setTimeout(publish, 250);   /* up to ~10s */
    })();
  }

  /* ---- the conversion itself ----
     Shopify reloads the page after a successful post, so the success state is
     what we detect. Fires once per page load. */
  function initLead() {
    if (window.__vjLeadFired) return;
    var ok = document.querySelector('.vj-success[data-vj-location]');
    if (!ok) return;
    window.__vjLeadFired = true;
    vjEmit('lead_submitted', {
      form_location: ok.getAttribute('data-vj-location') || '',
      label: 'enquiry submitted'
    });
  }


  /* ---- review carousel arrows (delegated from document) ---- */
  if (!window.__vjRailBound) {
    window.__vjRailBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.vjr-nav') : null;
      if (!btn) return;
      var wrap = btn.closest('.vjr-wrap');
      var rail = wrap && wrap.querySelector('.vjr-rail');
      if (!rail) return;
      e.preventDefault();
      var card = rail.querySelector('.vjr-card');
      var by = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.85;
      rail.scrollBy({ left: btn.classList.contains('vjr-prev') ? -by : by, behavior: 'smooth' });
    }, true);
  }

  /* ---- mirror each submission to the Google Sheet ----
     Uses sendBeacon rather than fetch. Shopify navigates away the instant the
     form posts, and a normal request gets cancelled mid-flight when that
     happens. sendBeacon is built for exactly this: the browser takes
     responsibility for delivering it after the page is gone.

     Fire and forget by design. If it fails, the customer still submits
     normally and Paula still gets the email. The sheet is the convenience
     copy, never the thing in the critical path. */
  if (!window.__vjLogBound) {
    window.__vjLogBound = true;
    document.addEventListener('submit', function (e) {
      try {
        var form = e.target;
        if (!VJ_SHEET_ENDPOINT) return;
        if (!form || !form.closest || !form.closest('.vj-form-card')) return;
        if (!navigator.sendBeacon) return;

        var data = new URLSearchParams();
        data.append('submitted_at', new Date().toISOString());
        data.append('page_url', window.location.href);

        Array.prototype.forEach.call(form.elements, function (el) {
          if (!el.name || el.type === 'submit') return;
          if (el.name === 'form_type' || el.name === 'utf8') return;
          /* contact[Campaign source] -> Campaign source */
          var key = el.name.replace(/^contact\[/, '').replace(/\]$/, '');
          data.append(key, el.value == null ? '' : el.value);
        });

        navigator.sendBeacon(VJ_SHEET_ENDPOINT, data);
      } catch (err) { /* never block a real submission */ }
    }, true);
  }

  /* ---- form engagement ----
     Fires once per form, on the first field focus. This is what lets you tell
     "nobody wanted the form" apart from "sixty people started and gave up",
     which is the difference between fixing the traffic and fixing the form. */
  if (!window.__vjFormBound) {
    window.__vjFormBound = true;
    document.addEventListener('focusin', function (e) {
      var field = e.target && e.target.closest ? e.target.closest('.vj-field input, .vj-field select, .vj-field textarea') : null;
      if (!field) return;
      var card = field.closest('.vj-form-card');
      if (!card || card.dataset.vjStarted) return;
      card.dataset.vjStarted = '1';
      var loc = card.querySelector('input[name="contact[Form location]"]');
      vjEmit('form_start', { form_location: loc ? loc.value : '', label: 'form start' });
    }, true);
  }

  /* ---- reaching the closing CTA ----
     Section-level signal for whether the lower half of a long page earns its
     place. GA4's built-in scroll event only fires at 90% of the document. */
  function initDepth() {
    var cards = document.querySelectorAll('.vj-form-card');
    if (cards.length < 2 || !window.IntersectionObserver) return;
    var last = cards[cards.length - 1];   /* the closing form, bottom of the page */
    if (last.dataset.vjDepth) return;
    last.dataset.vjDepth = '1';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          vjEmit('reached_closing_cta', { label: 'closing section' });
          io.disconnect();
        }
      });
    }, { threshold: 0.25 });
    io.observe(last);
  }

  /* ---- campaign attribution ----
     Captures UTMs / gclid on first landing, keeps them for the session, and
     writes them into the enquiry form's hidden fields. Means an emailed lead
     arrives with the campaign attached instead of anonymous. */
  var VJ_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid','fbclid','msclkid'];

  function vjCapture() {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('vj_attribution') || '{}'); } catch (e) {}

    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return stored; }

    var fresh = {};
    VJ_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) fresh[k] = v;
    });

    /* First touch wins. A visitor who arrives on an ad then wanders the site
       should still be credited to the ad, not to the internal page they
       happened to submit from. */
    if (Object.keys(fresh).length && !Object.keys(stored).length) {
      fresh.referrer = document.referrer || '';
      fresh.landing_page = window.location.pathname || '';
      stored = fresh;
      try { sessionStorage.setItem('vj_attribution', JSON.stringify(stored)); } catch (e) {}
    } else if (!Object.keys(stored).length) {
      stored = { referrer: document.referrer || '', landing_page: window.location.pathname || '' };
      try { sessionStorage.setItem('vj_attribution', JSON.stringify(stored)); } catch (e) {}
    }
    return stored;
  }

  function vjFillForm() {
    var data = vjCapture();
    document.querySelectorAll('input[data-vj-utm]').forEach(function (input) {
      var key = input.getAttribute('data-vj-utm');
      if (data[key]) input.value = data[key];
    });
  }

  /* ---- conversion click tracking (delegated, survives re-renders) ----
     Covers three things:
       1. our own [data-vj-event] buttons
       2. Google review links out of the carousel
       3. booking and phone links in Prestige's announcement bar and header,
          which are not our markup and carry no attributes, so they are matched
          on href instead. The header CTA is sticky and follows the visitor
          down the whole page, so it likely takes a real share of clicks. */
  if (!window.__vjTrackBound) {
    window.__vjTrackBound = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a, button') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var label = a.getAttribute('data-vj-label') || (a.textContent || '').trim().slice(0, 80);

      var name = a.getAttribute('data-vj-event');
      if (!name) {
        if (href.indexOf('acuityscheduling.com') > -1) name = 'booking_click';
        else if (href.indexOf('tel:') === 0) name = 'phone_click';
        else if (href.indexOf('google.com/local/reviews') > -1 || href.indexOf('search.google.com/local') > -1) name = 'review_click';
        else if (a.classList.contains('vjr-more') || a.classList.contains('vjr-all')) name = 'review_click';
      }
      if (!name) return;

      vjEmit(name, { label: label, destination: href });
    }, true);
  }

  /* ---- greyscale images, colour as they scroll into focus ----
     Adding .vj-ready to <html> is what switches the greyscale on. Doing it
     from here means a broken script leaves the images in colour rather than
     stuck grey. */
  function initReveal() {
    var els = document.querySelectorAll('.vj-reveal');
    if (!els.length) return;

    if (!window.IntersectionObserver) {
      document.documentElement.classList.remove('vj-ready');
      return;
    }

    document.documentElement.classList.add('vj-ready');

    if (!window.__vjObserver) {
      window.__vjObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.classList.toggle('vj-in-focus', en.isIntersecting);
        });
      }, { rootMargin: '-15% 0px -15% 0px', threshold: 0 });
      window.__vjSeen = new WeakSet();
    }

    els.forEach(function (el) {
      if (!window.__vjSeen.has(el)) {
        window.__vjSeen.add(el);
        window.__vjObserver.observe(el);
      }
    });
  }

  try {
    vjFillForm();
    document.addEventListener('DOMContentLoaded', vjFillForm);
    initReveal();
    initDepth();
    initLead();
    document.addEventListener('DOMContentLoaded', initReveal);
    document.addEventListener('DOMContentLoaded', initDepth);
    document.addEventListener('DOMContentLoaded', initLead);
    window.addEventListener('load', initLead);
    document.addEventListener('shopify:section:load', initReveal);
    window.addEventListener('load', initReveal);
  } catch (err) { /* decorative only, never block the page */ }
})();
